module.exports = __webpack_public_path__ + "static/media/photo-icon3.7cd458be.svg";